import React from "react";
import { Typography } from "@mui/material";
import { SECONDARY_COLOR } from "../../../constant/constant";

export const SectionHeader = ({ title, description }) => {
  return (
    <>
      <Typography
        variant="h6"
        sx={{
          pt: 2,
          pl: 2,
          fontWeight: 600,
        }}
      >
        {`${title} Plan`}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          pb: 2,
          pl: 2,
          color: SECONDARY_COLOR,
        }}
      >
        {description}
      </Typography>
    </>
  );
};
